module.exports = __webpack_public_path__ + "assets/img/world-news-network-active.a27e17c3.svg";